import { render, staticRenderFns } from "./ItemSkills.vue?vue&type=template&id=3aad4474&scoped=true"
import script from "./ItemSkills.vue?vue&type=script&lang=js"
export * from "./ItemSkills.vue?vue&type=script&lang=js"
import style0 from "./ItemSkills.vue?vue&type=style&index=0&id=3aad4474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aad4474",
  null
  
)

export default component.exports